import { Vault } from "../../libs/storage.js";

export { ExtraParams, ExtraParamsValues };

interface ExtraParamsValues {
  infoproduct_id: number | string;
  team_id: number | string;
}

class ExtraParams {
  private _currentExtraParams: ExtraParamsValues;

  constructor() {
    this._currentExtraParams = Vault.get("t_extra_params");
  }

  get currentExtraParams(): ExtraParamsValues {
    return this._currentExtraParams;
  }
}
